import React from 'react';
import './App.css';
import SessionContainer from './Components/SessionContainer';

function App() {

  return (
    <div className="App">
      <header className="App-header">
      <SessionContainer/>
      </header>
    </div>
  );
}

export default App;